import React, { PropsWithChildren } from 'react'

import Box from '@mui/material/Box'

import { Text } from '@mxenabled/mxui'

interface SubheaderRowProps {
  bgcolor?: string
}

const SubheaderRow: React.FC<PropsWithChildren<SubheaderRowProps>> = ({
  bgcolor = 'background.default',
  children,
}) => (
  <Box display="inline-block" sx={{ bgcolor, py: 6, width: '100%' }}>
    <Text bold={true} sx={{ pl: 24 }} variant="caption">
      {children}
    </Text>
  </Box>
)

export default SubheaderRow
